import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs, Card, Button, Dropdown, Table, Select, Checkbox, Form, ConfigProvider } from 'antd'
import { Link, useLocation } from "react-router-dom";
import { connect } from 'react-redux'

import "../Transfer/transfer.scss"
import './index.scss'
import GoBack from "components/goBack";
import { Spinner } from "constants/constants";
import SearchableColumn from "components/Table/ColumnSearch";
import CustomTooltip from "components/Tooltip";
import {
    BlueEditIcon,
    CloseIco, DeleteIco,
    PlusIco
} from "../../../modules/CustomIcons";
import SelectField from "components/SelectField";
import SortableColumn from "components/Table/ColumnSort";
import TableComponent from "components/Table";
import { getTemplates, getTemplatesByParams, Templates } from "../../services/Transfers/Templates";
import { trnTypes } from "../../../root/Routes/Routes";
import DeleteTemplate from "components/DeleteTemplate";
import EditTemplatePopup from "components/EditTemplatePopup";
import CreateNewTemplateModal from "components/CreateNewTemplateModal";
import {addStr, checkAmountForRequest, convertAmountFormatForRequest} from "../../services/helper";
import { CustomDataEmpty } from "components/customDataEmpty";
import { useTranslation } from 'react-i18next';


const TemplatesPage: React.FC<any> = ({ leftMenuStatus }) => {
    const {t} = useTranslation();
    const [tableData, setTableData] = useState<Templates[]>()
    const [dateFilterListMain, setDateFilterListMain] = useState<Templates[]>()
    const [tableListForSortOriginal, setTableListForSortOriginal] = useState<Templates[]>()
    const [tableLoading, setTableLoading] = useState(Spinner);
    const [current, setCurrent] = useState(1)
    const [deleteTemplateModalVisible, setDeleteTemplateModalVisible] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState<any>([]);
    const [selectedTemplates, setSelectedTemplates] = useState<any>([]);
    const [showPerPage, setShowPerPage] = useState<number>(10);
    const [editTemplateModalVisible, setEditTemplateModalVisible] = useState(false);
    const [editTemplateData, setEditTemplateData] = useState<Templates>();
    const [checkAll, setCheckAll] = useState<boolean>(false);
    const [createNewTemplateModalVisible, setCreateNewTemplateModalVisible] = useState(false);
    const [templateTrnList, setTemplateTrnList] = useState<any>([]);
    let location = useLocation()
    const [form] = Form.useForm();


    const [filtereValues, setFilteredValues] = useState({ "col_2": "", "col_3": "", "col_4": "", "col_5": "", "col_6": "", "col_8": "", "col_9": "" })

    const handleFilterColumn = (e: any, column: string) => {
        let newfiltereValues = filtereValues;


        if (column === 'col_2') {
            newfiltereValues.col_2 = e?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_3') {
            newfiltereValues.col_3 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_4') {
            newfiltereValues.col_4 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_5') {
            newfiltereValues.col_5 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_6') {
            newfiltereValues.col_6 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_8') {
            newfiltereValues.col_8 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_9') {
            newfiltereValues.col_9 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }


        if (dateFilterListMain && filtereValues) {

            let filteredData: any;
            filteredData = dateFilterListMain?.filter((sRow: any) => ((filtereValues["col_2"] === 'all' || filtereValues["col_2"] === '' ? sRow : sRow?.row.trnType?.toLowerCase() === (filtereValues["col_2"])) && sRow.col_3.template_name ? sRow.col_3?.template_name?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_3"]) : filtereValues["col_3"] === '' ? sRow.col_3?.template_name === undefined : "") && (sRow.col_4.pan ? sRow.col_4?.pan?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_4"]) : filtereValues["col_4"] === '' ? sRow.col_4?.pan === undefined : "") && (sRow.col_5.account ? sRow.col_5?.account?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_5"]) : filtereValues["col_5"] === '' ? sRow.col_5?.account === undefined : "") && (sRow.col_6.info ? sRow.col_6?.info?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_6"]) : filtereValues["col_6"] === '' ? sRow.col_6?.info === undefined : "") && (sRow.col_8.currency ? sRow.col_8?.currency?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_8"]) : filtereValues["col_8"] === '' ? sRow.col_8?.currency === undefined : "") && (sRow.col_9.created ? sRow.col_9?.created?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_9"]) : filtereValues["col_9"] === '' ? sRow.col_9?.created === undefined : ""));



            // filtereValues["col_2"] === 'all' || filtereValues["col_2"] === '' ? sRow : sRow?.row.trnType?.toLowerCase()===(filtereValues["col_2"])  && 


            setTableData(old_data => filteredData);
            setTableListForSortOriginal(old => filteredData)

            if (filtereValues["col_2"] === 'all') {
                form.resetFields(['status_filter'])
            }
        }
    }

    // const trnTypeSelected = (value : string) => {
    //     fetchData(value);
    // }

    const tableColumns = [
        {
            title: (
                <div className="full flex" style={{ marginTop: '-4px'}}>
                    <Form form={form}>
                        <SelectField
                            width={'100%'}
                            placeholder={t("common.all")}
                            options={templateTrnList}
                            className={"status-select"}
                            // onChange={trnTypeSelected}
                            onChange={(value: string) => handleFilterColumn(value, 'col_2')}
                            name={'status_filter'}
                            required={false}
                            headerCheck={true}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_2',
            key: 'col_2',
            className: 'col_2 ant-table-cell-ellipsis',
            onCell: (record) => {
                return {
                    onClick: () => toggleMoreTable(record),
                };
            },
            render: (data, record) => (
                <div className={'full flex'}>
                    <CustomTooltip title={data.tooltip}  >
                        <p className='has_balance' >{data.account_type}</p>
                    </CustomTooltip>
                </div>
            )
        },
        {
            title: (
                <div className="templateForm" >
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            form={form}
                            name={"template_name"}
                            filter={"searchfilter"}
                            title={t("transfers.templateName")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_3')}
                        />
                    </Form>
                    {/* <SearchableColumn title={t("transfers.templateName")} /> */}
                </div>
            ),
            dataIndex: 'col_3',
            key: 'col_3',
            className: 'col_3 ant-table-cell-ellipsis',
            onCell: (record, rowIndex) => {
                return {
                    onClick: (ev) => toggleMoreTable(record),
                };
            },
            render: (data, record) => {
                let check_text = data.template_name || '';

                return <div className={'full flex'}>
                    {
                        check_text.toString().length > 19 ? <CustomTooltip title={data.template_name} > <p>{addStr(data.template_name, 19)}</p>  </CustomTooltip> : <p>{data.template_name}</p>
                    }
                </div>
            }
        },
        {
            title: (
                <div className="templateForm" >
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            form={form}
                            name={"from_account"}
                            filter={"searchfilter"}
                            title={t("transfers.fromAccount")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_4')}
                        />
                    </Form>
                    {/* <SearchableColumn title={t("transfers.fromAccount")} /> */}
                </div>
            ),
            dataIndex: 'col_4',
            key: 'col_4',
            className: ' col_4 ant-table-cell-ellipsis',
            onCell: (record) => {
                return {
                    onClick: (ev) => toggleMoreTable(record),
                };
            },
            render: (data, record) => {
                let p_classname = parseFloat(data.title) > 0 ? 'has_blocked_amount' : 'no_blocked_amount';
                return (
                    <div className={'full flex'}>
                        {data.pan?.length > 16 ? <CustomTooltip title={data.pan} > <p>{addStr(data.pan, 16)}</p>  </CustomTooltip> : <p>{data.pan}</p>}
                    </div>
                )
            }
        },
        {
            title: (
                <div className="templateForm" >
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            form={form}
                            name={"alias"}
                            filter={"searchfilter"}
                            title={t("transfers.accountAlias")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_5')}
                        />
                    </Form>
                    {/* <SearchableColumn title={'Hesaba/Alias'} /> */}
                </div>
            ),
            dataIndex: 'col_5',
            key: 'col_5',
            className: ' col_5 ant-table-cell-ellipsis',
            onCell: (record) => {
                return {
                    onClick: (ev) => toggleMoreTable(record),
                };
            },
            render: (data, record) => {
                return (
                    <div className={'full flex'}>
                        {data.account?.length > 16 ? <CustomTooltip title={data.account} > <p>{addStr(data.account, 16)}</p>  </CustomTooltip> : <p>{data.account}</p>}
                    </div>
                )
            }
        },
        {
            title: (
                <div className="templateForm" >
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            form={form}
                            name={"pay_info"}
                            filter={"searchfilter"}
                            title={t("accountStatement.paymentDetails")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_6')}
                        />
                    </Form>
                    {/* <SearchableColumn title={t("accountStatement.paymentDetails")} /> */}
                </div>
            ),
            dataIndex: 'col_6',
            key: 'col_6',
            className: ' col_6 ant-table-cell-ellipsis',
            onCell: (record) => {
                return {
                    onClick: (ev) => toggleMoreTable(record),
                };
            },
            render: (data, record) => {
                let text = data.info;
                let check_text = text || '';

                return <div className={'full flex'} >
                    {check_text?.length > 29 ?
                        <CustomTooltip title={data.info} className={'tooltip_slim'}>
                            <p>{text}</p>
                        </CustomTooltip>
                        : <p>{text}</p>
                    }
                </div>
            }
        },
        {
            title: (
                <div className="full flex justify_end sort_col">
                    <SortableColumn
                        data={tableData}
                        setData={setTableData}
                        dataOriginal={tableListForSortOriginal}
                        type={"number"}
                        parameter={"col_7"}
                        paramater_second={"amount"}
                    />
                    <span>{t("common.amount")}</span>
                </div>
            ),
            dataIndex: 'col_7',
            key: 'col_7',
            className: 'column7 col_7 ant-table-cell-ellipsis',
            onCell: (record) => {
                return {
                    onClick: (ev) => toggleMoreTable(record),
                };
            },
            render: (data, record) => {
                const value = convertAmountFormatForRequest(data.amount);
                return (
                    <div className={'full flex justify_end'}>
                        <p>{value}</p>
                    </div>
                )
            }
        },
        {
            title: (
                <div className="templateForm" >
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            form={form}
                            name={"currency"}
                            filter={"searchfilter"}
                            title={t("home.currency")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_8')}
                        />
                    </Form>
                    {/* <SearchableColumn title={t("home.currency")} /> */}
                </div>
            ),
            dataIndex: 'col_8',
            key: 'col_8',
            className: 'column8 col_8 ant-table-cell-ellipsis',
            onCell: (record) => {
                return {
                    onClick: (ev) => toggleMoreTable(record),
                };
            },
            render: (data, record) => (
                <div className={'full flex'} >
                    <p>{data.currency}</p>
                </div>
            ),
        },
        {
            title: (
                <div className="templateForm" >
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            form={form}
                            name={"creator"}
                            filter={"searchfilter"}
                            title={t("templates.createdBy")}
                            onChange={(event: any) => handleFilterColumn(event, 'col_9')}
                        />
                    </Form>
                    {/* <SearchableColumn title={t("templates.createdBy")} /> */}
                </div>
            ),
            onCell: (record) => {
                return {
                    onClick: (ev) => toggleMoreTable(record),
                };
            },
            dataIndex: 'col_9',
            key: 'col_9',
            className: 'column9 col_9 ant-table-cell-ellipsis',
            render: (data, record) => (
                <div className={'full flex'}>
                    <p>{data.created}</p>
                </div>
            ),
        }
    ];

    const fetchData = async (selectedTrnList: string = '') => {
        setTableLoading({
            ...tableLoading,
            spinning: true
        });

        const data = await getTemplatesByParams();

        let temp_array = [];
        const trynTypeList = [{
            value: 'all',
            label: t("common.all"),
            title: ''
        }];


        for (let row of data) {
              
            const find = trynTypeList?.find(row2 => row2.value == row.trnType)

            if (!find) {
                trynTypeList.push({
                    value: row.trnType,
                    // label: trnTypes[row.trnType].title,
                    title: trnTypes[row.trnType]?.shortName
                });
            }



            if (selectedTrnList && row.trnType !== selectedTrnList) {
                continue;
            }
            row.trnData.PMTDET = `${row.trnData.MAINDET !== undefined && row.trnData.MAINDET !== null ? (row.trnData.MAINDET+' ') : ""}${row.trnData.PMTDET!== undefined && row.trnData.PMTDET!== null ? row.trnData.PMTDET :''}`;
            
            // @ts-ignore
            temp_array.push(
                {
                    key: row.templateId,
                    col_1: {},
                    col_2: { account_type: trnTypes[row.trnType]?.shortName, tooltip: trnTypes[row.trnType]?.title },
                    col_3: { template_name: row.templateName },
                    col_4: { pan: row.trnData?.CUSTACC, iban: row.trnData?.CUSTACC },
                    col_5: { account: row.trnData.BENEFACC },
                    col_6: { info: row.trnData.PMTDET },
                    col_7: { amount: row.trnData.AMOUNT },
                    col_8: { currency: row.trnData.pmtCurr ? row.trnData.pmtCurr : 'AZN' },
                    col_9: { created: row.userName },
                    data: {
                        account_name: row.trnData.BENEFNAME,
                        iban: row.trnData.BENEFACC,
                        voen: row.trnData.BENEFTAXID,
                        code: row.trnData.BENEFBANKCODE,
                        bank_name: row.trnData.BENEFBANKNAME,
                        amount: `${convertAmountFormatForRequest(row.trnData.AMOUNT)} ${row.trnData.pmtCurr ? row.trnData.pmtCurr : 'AZN'}`,
                        desc: row.trnData.PMTDET,
                    },
                    transferDocs: row.trnData.transferDocs,
                    row: row
                }
            );
        }

        setSelectedTemplates(old_data => [])
        setTemplateTrnList(old_data => trynTypeList)
        setTableData(old_data => temp_array);
        setTableListForSortOriginal(old_data => temp_array)
        setDateFilterListMain(old_data => temp_array)
        setTableLoading({
            ...tableLoading,
            spinning: false
        });

    };

    useEffect(() => {
        fetchData();

    }, []);

    useEffect(() => {
        // setDateIndex(1)
        // setTableData([])
        setCurrent(1)
    }, [location.pathname])

    const toggleMoreTable = (record: any) => {

        let key = record.key,
            check_index = expandedRowKeys.indexOf(key);

        if (check_index === - 1) {
            setExpandedRowKeys(old_array => [key]);
        } else {
            expandedRowKeys.splice(check_index, 1);

            setExpandedRowKeys(old_array => [...expandedRowKeys]);
        }

    }

    const editTemplate = (record: any) => {
      
        setEditTemplateData(old_data => record.row);
        setEditTemplateModalVisible(old_data => true)
    }

    const expandedRowRender = () => {
        return {
            expandedRowRender: (record) => {
                
                let row_data = record.data;
                let type = record.col_2?.account_type;
                const value = row_data.amount
                return (
                    <div className={'full  template_child_tables'} >
                        <Button icon={<CloseIco />} onClick={() => toggleMoreTable(record)} className={'transparent sub_table_close_icon'} type={"ghost"} />

                        <div className={'flex direction_column template_child_table template_child_table_1'} >
                            <h3>{t("transfers.beneficiary")}</h3>

                            <ul className={'flex direction_column'} >
                                <li>
                                    <label>{t("requisites.name")}</label>
                                    <span>{row_data.account_name}</span>
                                </li>
                                <li>
                                    <label>{t("deposit.accountNumber")}</label>
                                    <span>{row_data.iban}</span>
                                </li>
                                <li>
                                    <label>{t("requisites.taxID")}</label>
                                    <span>{row_data?.voen !== undefined && row_data?.voen !== null ? row_data?.voen : ""}</span>
                                </li>
                            </ul>
                        </div>

                        <div className={'flex direction_column template_child_table template_child_table_2'} >
                            <h3>{t("newTransfer.beneficiaryBank")}</h3>

                            <ul className={'flex direction_column'} >
                                <li>
                                    <label>{t("requisites.code")}</label>
                                    <span>{row_data.code}</span>
                                </li>
                                <li>
                                    <label>{t("requisites.name")}</label>
                                    <span>{row_data.bank_name !== undefined ? row_data.bank_name : (type === 'IT' || type === 'IM' ? "\"Bank Respublika\" ASC" : row_data.bank_name)}</span>
                                </li>
                            </ul>
                        </div>

                        <div className={'flex direction_column template_child_table template_child_table_3'} >
                            <h3>&nbsp;</h3>

                            <ul className={'flex direction_column'} >
                                <li>
                                    <label>{t("common.amount")}</label>
                                    <span>{value}</span>
                                </li>
                                <li>
                                    <label>{t("accountStatement.paymentDetails")}</label>
                                    <span>{row_data.desc}</span>
                                </li>
                            </ul>
                        </div>

                        <div className={'full flex justify_end'} >
                            <ul className={'flex sub_table_btn_list'} >
                                <li>
                                    <Link to={{
                                        pathname: trnTypes[record.row.trnType].url,
                                        state: record.row
                                    }} type={"ghost"} htmlType={"button"} className={'ant-btn ant-btn-ghost'} >
                                        <PlusIco />
                                        <span>{t("salary.createTransfer")}</span>
                                    </Link>
                                </li>

                                <li>
                                    <Button type={"ghost"} htmlType={"button"} onClick={() => editTemplate(record)} >
                                        <BlueEditIcon />
                                        {t("transfers.edit")}
                                    </Button>
                                </li>

                                <li>
                                    <Button type={"ghost"} htmlType={"button"} onClick={() => { setSelectedTemplates(old_data => [record.row.templateId]); setDeleteTemplateModalVisible(true) }} >
                                        <DeleteIco />
                                        {t("home.deleteTemplate")}
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    </div>
                )
            },
            rowExpandable: record => record.data,
            expandRowByClick: false,
            expandedRowKeys: expandedRowKeys
        };
    };

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows) => {

            let get_keys = selectedRows.map(row => {
                return row.key
            });

            setSelectedTemplates(old_data => get_keys);
        },
        getCheckboxProps: (record) => {

            //setSelectedTemplates(old_data => []);
        },
    };

    const rowClassName = (record: any, index: number) => {
        let className = '';
        className = index % 2 ? 'table-row-light' : 'table-row-dark' + ' ' + (expandedRowKeys.indexOf(record.key) !== -1 ? `row_${index} opened_row ` : ` row_${index} `);
        return className;
    }

    const customizeRenderEmpty = () => (
        <CustomDataEmpty value={t("credits.noLoans")} />
    )

    // @ts-ignore
    return (
        <>
            {/*<Row>*/}
            {/*  <Col span={24} className="transfer">*/}
            {/*    <GoBack title={t("home.templates")} />*/}
            {/*    <Tabs*/}
            {/*        type="card"*/}
            {/*        className={`transfer_parent_tab template_parent_tab`}*/}
            {/*        destroyInactiveTabPane={true}*/}
            {/*    >*/}
            {/*  template_tabs*/}
            <Row className={'cur_exchange_bg account_child_tabsTemplate templateTab'}>
                <Col span={24}>
                    <Card bordered={false}>
                        {
                            tableData?.length > 0 && <div className={'full flex justify_end template_pagination template_pagination_top'} >
                                <div className="flex pagination-selector ">
                                    <p>{t("salary.numberAtPage")}</p>
                                    <Select className={'table_pagination'} defaultValue={showPerPage} onChange={(value) => setShowPerPage(old_value => value)} >
                                        <option value={10}>{10}</option>
                                        <option value={50}>{50}</option>
                                        <option value={100}>{100}</option>
                                    </Select>
                                </div>
                            </div>
                        }

                        <Form className="own-account__form">


                            {/*<ConfigProvider renderEmpty={customizeRenderEmpty}>*/}
                            {/*{ tableData?.length > 0 &&*/}
                            <TableComponent
                                loading={tableLoading}
                                columns={tableColumns}
                                data={tableData}
                                className="transfer-table home_account_table table-hover home_hesab_table  home_content_table templates_table home_account_opt_table"
                                scroll={{ x: '100%' }}
                                pagination={true}
                                pageSize={showPerPage}
                                onPageChange={(page: number) => setCurrent(page)}
                                current={current}
                                paginationClassName={'template_pagination template_pagination_bottom'}
                                expandable={expandedRowRender()}
                                rowClassName={rowClassName}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...rowSelection,
                                }}

                                position="bottom center"
                                alignment="center"
                            // locale={{emptyText: (<div style={{ height: '80vh', alignItems: "center", justifyItems: "center", display: "flex"}}>
                            //     <div className={'noDataTransfer'}>
                            //     <div className={'noDataTransferDiv'}>Şablon mövcud deyil</div>
                            //     </div>
                            //     </div>)}}
                            />
                            {tableData?.length === 0 && <div className={'noDataTemplate'}>
                                <div className={'noDataTemplateDiv'}>{t("templates.noTemplate")}</div>
                            </div>}
                            {/*}*/}

                            {/*{tableData?.length < 1 &&*/}
                            {/*    <div style={{ height: '80vh', alignItems: "center", justifyItems: "center", display: "flex"}}>*/}
                            {/*        <div className={'noDataTransfer'}>*/}
                            {/*            <div className={'noDataTransferDiv'}>Şablon mövcud deyil</div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*}*/}

                            <ul className={'flex sub_table_btn_list sub_table_btn_list_inside_form'} >
                                <li>
                                    <Button
                                        type={"ghost"}
                                        htmlType={"button"}
                                        className={'no_bg'}
                                        onClick={() => setCreateNewTemplateModalVisible(old_data => true)}
                                    >
                                        <PlusIco />
                                        {t("templates.addNewTemplate")}
                                    </Button>
                                </li>
                                <li>
                                    <Button
                                        type={"ghost"}
                                        htmlType={"button"}
                                        className={'no_bg delete_template_btn'}
                                        disabled={!selectedTemplates.length}
                                        onClick={() => setDeleteTemplateModalVisible(selectedTemplates.length > 0)}
                                    >
                                        <DeleteIco />
                                        {t("home.deleteTemplate")}
                                    </Button>
                                </li>
                            </ul>
                            {/*</ConfigProvider>*/}
                        </Form>

                        {/*<div style={{ display: "none" }} className={'full flex justify_between align_center table_bottom_btn'} >*/}

                        {/*    <ul className={'flex sub_table_btn_list'} >*/}
                        {/*        <li>*/}
                        {/*            <Button type={"ghost"} htmlType={"button"} className={'no_bg'} >*/}
                        {/*                <PlusIco />*/}
                        {/*                {t("templates.addNewTemplate")}*/}
                        {/*            </Button>*/}
                        {/*        </li>*/}

                        {/*        <li>*/}
                        {/*            <Button type={"ghost"} htmlType={"button"} className={'no_bg'} disabled={true} >*/}
                        {/*                <DeleteIco />*/}
                        {/*                Şablonu sil*/}
                        {/*            </Button>*/}
                        {/*        </li>*/}
                        {/*    </ul>*/}

                        {/*    <ul className={'flex sub_table_btn_list'} >*/}
                        {/*        <li>*/}
                        {/*            <Button type={"ghost"} htmlType={"button"} className={'white_bg'} >*/}
                        {/*                <PlusIco />*/}
                        {/*                Köçürmə yarat*/}
                        {/*            </Button>*/}
                        {/*        </li>*/}

                        {/*        <li>*/}
                        {/*            <Button type={"ghost"} htmlType={"button"} className={'white_bg'} disabled={true} >*/}
                        {/*                <BlueEditIcon />*/}
                        {/*                Redaktə et*/}
                        {/*            </Button>*/}
                        {/*        </li>*/}

                        {/*        <li>*/}
                        {/*            <Button type={"ghost"} htmlType={"button"} className={'white_bg'} disabled={true} >*/}
                        {/*                <DeleteIco />*/}
                        {/*                Şablonu sil*/}
                        {/*            </Button>*/}
                        {/*        </li>*/}
                        {/*    </ul>*/}

                        {/*</div>*/}
                    </Card>
                </Col>
            </Row>
            {/*    </Tabs>*/}
            {/*  </Col>*/}
            {/*</Row>*/}

            {
                deleteTemplateModalVisible && <DeleteTemplate
                    visible={deleteTemplateModalVisible}
                    onClose={setDeleteTemplateModalVisible}
                    templateIds={selectedTemplates}
                    callBackApi={fetchData}
                />
            }

            {
                editTemplateModalVisible && <EditTemplatePopup
                    visible={editTemplateModalVisible}
                    onClose={setEditTemplateModalVisible}
                    templateData={editTemplateData}
                    callBackApi={fetchData}
                />
            }

            {
                createNewTemplateModalVisible && <CreateNewTemplateModal
                    visible={createNewTemplateModalVisible}
                    onClose={setCreateNewTemplateModalVisible}
                />
            }
        </>
    )
}
const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
})
export default connect(mapStateToProps, null)(TemplatesPage)
